var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 24C0.5 37.2548 11.2452 48 24.5 48C37.7548 48 48.5 37.2548 48.5 24C48.5 10.7452 37.7548 0 24.5 0C11.2452 0 0.5 10.7452 0.5 24Z",
    fill: "#0088CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5999 23.0418C21.8949 21.1705 24.7589 19.9369 26.1919 19.3409C30.2834 17.6391 31.1335 17.3435 31.6877 17.3336C31.8095 17.3315 32.082 17.3618 32.2586 17.505C32.4076 17.6259 32.4486 17.7893 32.4683 17.904C32.4879 18.0186 32.5123 18.2799 32.4929 18.484C32.2712 20.8136 31.3118 26.467 30.8237 29.0762C30.6172 30.1803 30.2105 30.5505 29.8168 30.5867C28.9613 30.6654 28.3116 30.0213 27.4829 29.4781C26.1862 28.6281 25.4537 28.0989 24.195 27.2695C22.7404 26.3109 23.6834 25.7841 24.5124 24.9231C24.7293 24.6978 28.499 21.269 28.5719 20.9579C28.5811 20.919 28.5895 20.774 28.5034 20.6974C28.4172 20.6209 28.2901 20.647 28.1983 20.6679C28.0683 20.6974 25.9968 22.0666 21.9839 24.7754C21.3959 25.1791 20.8633 25.3759 20.3862 25.3656C19.8601 25.3542 18.8482 25.0681 18.096 24.8236C17.1733 24.5237 16.44 24.3651 16.5039 23.8558C16.5371 23.5905 16.9025 23.3191 17.5999 23.0418Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.bf8b52b785b1f0780017a4dba0d71338.svg";
export { ForwardRef as ReactComponent };